<template>
    <div>
        <header id=aha-header class="l-header" style="background-color:#C10E21; color:white " v-if="fetchingError">
            <div class="container p-5">
                <div>{{errorMsg}}</div>
            </div>
        </header>
        <header id=aha-header class="l-header" v-else> 
            <div v-html="refinedHTML.header"></div>
        </header>

         

        <div class="container container-fluid template">
            <div class="row mb-4 mt-5 aha-bg-gray p-4">
                    <div class="col-sm-12 col-md-8">
                        <h1>
                            AHA Header Footer HTML Markup
                        </h1>
                        <p class="lead p-4 aha-card">
                        + No plugins, no dependencies, and no framework. <br/>+ Highly extensible. <br/>+ Just HTML markup, CSS, and a sprinkle of vanilla JS.
                        </p>

                        <p class="small p-2">
                            Not your cup of tea? Rather use jQuery plugin.
                        <a href="http://static.heart.org/ahaanywhere/sitecore/headless-header-footer-plugin.html" class="d-block">Get jQuery Header Footer Plugin Here</a>
                        </p>


                    </div>
                    <div class="col-sm-12 col-md-4">
                        
                        <svg class="w-100" style="height:200px;" id="e7e3dec0-027d-49b8-bdc7-ccab56ef871f" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="770" height="431" viewBox="0 0 770 431"><polygon points="622.385 419.921 613.405 419.92 609.133 385.282 622.387 385.282 622.385 419.921" fill="#9e616a"/><path d="M839.67527,663.12563l-28.95638-.00107v-.36626a11.27124,11.27124,0,0,1,11.27063-11.27044h.00072l17.68556.00071Z" transform="translate(-215 -234.5)" fill="#2f2e41"/><polygon points="549.281 419.627 540.546 417.543 544.427 382.858 557.319 385.934 549.281 419.627" fill="#9e616a"/><path d="M764.48915,663.12563l-28.166-6.71909.085-.35625a11.27124,11.27124,0,0,1,13.57791-8.34808l.0007.00016,17.20284,4.10385Z" transform="translate(-215 -234.5)" fill="#2f2e41"/><circle cx="583.16598" cy="107.85215" r="18.99444" fill="#9e616a"/><path d="M843.02656,477.81507s8.84223,10.47969-2.29242,26.52671-21.421,31.76654-21.421,31.76654l-24.88926,47.15862L767.85067,645.899s-16.047-4.58488-16.702-6.54982,19.041-64.92453,19.041-64.92453,3.82745-25.10615,8.08481-33.29338,14.93821-70.7561,25.09038-71.41109S843.02656,477.81507,843.02656,477.81507Z" transform="translate(-215 -234.5)" fill="#2f2e41"/><path d="M841.32206,496.482l1.17588,50.761s5.59948,43.158,2.32461,58.22262-4.617,39.697-4.617,39.697l-16.702-1.63745-1.30989-58.62072s-4.58488-9.82469-3.27491-14.08208-5.56733-39.29883-5.56733-39.29883Z" transform="translate(-215 -234.5)" fill="#2f2e41"/><path d="M785.91109,479.45294c9.82445,10.477,58.75221,1.63427,58.75221,1.63427l-.65229-7.53156.68363-6.87277-1.96372-32.09624a362.02116,362.02116,0,0,1-.20395-38.63049,20.65459,20.65459,0,0,0-.25362-4.21235c-3.37594-20.536-20.73148-33.11879-21.65008-32.80842-.46241.152-5.38423,2.71748-10.52128,5.41587-5.89732,3.09751-12.07332,6.37238-12.07332,6.37238-7.861,2.95182-6.54962,50.11114-9.17216,54.36783s0,18.99044,0,18.99044l-2.94542,14.08126S776.08636,468.97591,785.91109,479.45294Z" transform="translate(-215 -234.5)" fill="#cacaca"/><path d="M817.65087,375.48733s9.16972,27.50916,7.20478,46.17612-23.2518,72.04784-23.2518,72.04784l-7.20479,3.92987v9.16972l-5.06746-13.72637,13.93558-29.13805S785.88435,363.37018,817.65087,375.48733Z" transform="translate(-215 -234.5)" opacity="0.1" style="isolation:isolate"/><path d="M804.41955,350.43161a12.77642,12.77642,0,0,0-.76751-3.453c-.83362-1.56893-2.74925-2.22624-4.51923-2.38035-2.25966-.19674-4.53675.19459-6.79963.03963s-4.68054-1.01716-5.80687-2.986a13.69775,13.69775,0,0,0-1.267-2.39066c-1.24051-1.41706-3.50119-1.19731-5.28394-.59007s-3.64167,1.49449-5.46405,1.01926c-1.53222-4.2871.35441-9.23238,3.61775-12.40687s7.66489-4.88271,12.03592-6.156c5.76544-1.67945,12.25385-2.672,17.55476.14951,7.68668,4.09143,10.39918,14.92,9.6902,22.99138-.268,3.05084-.70657,6.50564-3.17292,8.56566C810.62248,355.85315,805.5108,355.59389,804.41955,350.43161Z" transform="translate(-215 -234.5)" fill="#2f2e41"/><path d="M786.837,519.88789a7.73948,7.73948,0,0,0,.24926-11.865l10.30724-25.49918-14.01066,2.82336-7.63994,23.78161a7.78144,7.78144,0,0,0,11.0941,10.75919Z" transform="translate(-215 -234.5)" fill="#9e616a"/><path d="M816.69327,371.05327s9.16973,27.50918,7.20479,46.17613-23.25181,72.04783-23.25181,72.04783l-7.20478,3.92987v9.16972l-15.06453-4.25737,3.27491-10.80718s-5.23985-6.5498-1.63746-8.51473,2.94743-12.77212,2.94743-12.77212S784.92672,358.93614,816.69327,371.05327Z" transform="translate(-215 -234.5)" fill="#cacaca"/><path d="M621.68441,663.34961H295.53748V234.5H621.68441Z" transform="translate(-215 -234.5)" fill="#fff"/><path d="M621.68441,663.34961H295.53748V234.5H621.68441ZM298.4406,660.44649H618.78129V237.40312H298.4406Z" transform="translate(-215 -234.5)" fill="#e4e4e4"/><rect x="129.55666" y="108.47867" width="227.02744" height="15.13516" fill="#e4e4e4"/><rect x="181.44865" y="54.42452" width="145.94621" height="7.56758" fill="#e4e4e4"/><rect x="129.55666" y="141.99225" width="227.02744" height="15.13516" fill="#e4e4e4"/><rect x="129.55666" y="175.50583" width="227.02744" height="15.13517" fill="#e4e4e4"/><circle cx="141.44858" cy="57.66777" r="14.05408" fill="#f50057"/><rect x="127.39449" y="225.72214" width="229.18961" height="139.45972" fill="#f50057"/><path d="M355.31844,619.24973a7.56758,7.56758,0,0,0-10.71258,10.69176l10.69176,10.71257,10.71258-10.69175a7.56758,7.56758,0,0,0-10.69176-10.71258Z" transform="translate(-215 -234.5)" fill="#ff6582"/><path d="M984,665.5H216a1,1,0,0,1,0-2H984a1,1,0,0,1,0,2Z" transform="translate(-215 -234.5)" fill="#cacaca"/></svg>
                    </div>
            </div>
            <div class="row mt-5">
               
                <div class="col">
                    
                    <code-highlight class="w-100" language="html">
                        <pre class="w-100">
                            <code>
&lt;!doctype html&gt;
&lt;html lang=""&gt;
&lt;head&gt;
    &lt;link 
    href="css/aha-header-footer.css" 
    rel="stylesheet"&gt;
&lt;/head&gt;                      
&lt;body&gt;
    &lt;header&gt; ... &lt;/header&gt;
    // your content...
    &lt;footer&gt; ... &lt;/footer&gt;
    &lt;script 
    type="text/javascript" 
    src="js/aha-header-footer-main.js"&gt;
    &lt;/script&gt;
&lt;/body&gt;
&lt;/html&gt;
                            </code>
                        </pre>
                               

                    </code-highlight>
                    
                </div>
                    
                    <div class="col">
                        <h2>THE BASICS</h2>
                    <p class="lead">
                        HTML, CSS and JS
                    </p>
                    <p>
                        To use American Heart Association's header and footer on your site, just simply copy and paste the style, header / footer markups and script. The script allows the footer menu to collapse and expand in mobile. Place the script just before the closing of the &lt;/body&gt; tag at the bottom.
                    </p>

                    <div style="background-color:#C10E21; color:white " v-if="fetchingError">
                        <div class="p-5">
                            <div>{{errorMsg}}</div>
                        </div>
                    </div>

                    <ul class="list-group list-group-flush" v-else>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <span>Style</span>
                            <span>
                                <button type="button"
                                    class="template__btn"
                                    v-clipboard:copy="refinedHTML.csslink"
                                    v-clipboard:success="onCopy"
                                >Copy
                                </button>
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <span>Header Markup</span>
                            <span>
                                <button type="button"
                                    class="template__btn"
                                    v-clipboard:copy="refinedHTML.header"
                                    v-clipboard:success="onCopy"
                                >Copy
                                </button>
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <span>Footer Markup</span>
                            <span>
                                <button type="button"
                                    class="template__btn"
                                    v-clipboard:copy="refinedHTML.footer"
                                    v-clipboard:success="onCopy"
                                >Copy
                                </button>
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <span>Footer Script</span>
                            <span>
                                <button type="button"
                                    class="template__btn"
                                    v-clipboard:copy="refinedHTML.jslink"
                                    v-clipboard:success="onCopy"
                                >Copy
                                </button>
                            </span>
                        </li>
                    </ul>

           
                </div>
                    
                </div>
            </div>


        <div class="container container-fluid">
            <div class="row m-5">
                <div class="col-sm-12 text-center">
                    <h2>THE EXAMPLES</h2>
                </div>
                <div class="col d-flex justify-content-center align-items-center">
                    
                    <ul class="nav">
                        <li class="nav-item lead" style="border-right:1px solid #bbb;">
                            <a class="nav-link" href="https://static.heart.org/ahaanywhere/sitecore/dist/aha-header.html" target="_blank">Header</a>
                        </li>
                        <li class="nav-item lead">
                            <a class="nav-link" href="https://static.heart.org/ahaanywhere/sitecore/dist/aha-footer.html" target="_blank">Footer</a>
                        </li>
                    </ul>

                </div>
            </div>

        </div>  
   
        <div class="aha-bg-gray">
                <div class="container container-fluid ">
                    <div class="row mt-5">
                        <div class="col-12 d-flex p-4 align-items-center">
                            <div class="col-sm-8">
                                <h2 class="mb-5" style="font-size:3.5rem">
                                    The Style
                                </h2>
                                <div class="d-flex align-items-center">
                                    <div class="p-4" style="border-right: 1px solid #555">

                                    <div class="aha-single-letter-heading">
                                    F
                                    </div>
                                    <span>Font</span>
                                    </div>
                                    <p class="lead text-break p-4" style="letter-spacing:4px;">
                                        <span><a href="https://fonts.google.com/specimen/Montserrat?query=mont">Montserrat</a></span>
                                    ABCDEFGHIJKLMNOPQRSTUVWXYZ<br/>abcdefghijklmnopqrstuvwxyz<br/>1234567890
                                    </p>
                                </div>
                                
                            </div>
                        
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-12 d-flex p-4 align-items-center aha-bg-gray">
                            <div class="col-sm-12">
                                
                                <div class="d-flex align-items-center">
                                    <div class="p-4" style="border-right: 1px solid #555">

                                    <div class="aha-single-letter-heading">
                                    C
                                    </div>
                                    <span>Colors</span>
                                    </div>
                                    <div class="w-100 p-4">
                                        <div class="w-100 p-2" style="background-color:#C10E21; color:white">
                                                #C10E21
                                        </div>
                                        <div class="w-100 p-2" style="background-color:#9d0b1b; color:white">
                                                #9d0b1b
                                        </div>
                                        <div class="w-100 p-2" style="background-color:#e9ecef; color:gray">
                                                #e9ecef
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
        </div>

        <footer id=aha-footer class="l-footer" style="background-color:#C10E21; color:white " v-if="fetchingError">
            <div class="container p-5">
                <div>{{errorMsg}}</div>
            </div>
        </footer>
        <footer id="aha-footer" class="l-footer" v-else>
            <div v-html="refinedHTML.footer"></div>
        </footer>
    </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import CodeHighlight from "vue-code-highlight/src/CodeHighlight.vue";
import "vue-code-highlight/themes/duotone-sea.css";
import "vue-code-highlight/themes/window.css";
import FooterMenu from '@/scripts/aha-header-footer-main';
export default {
  name: 'Home',
  components:{
    CodeHighlight
  },
  data() {
    return {
        endpoints: {
            prod: 'https://www.heart.org/x-sitecore-service/layoutservice/index?route=/',
            dev: './data/data.json'
        },
        rawHTML: {
            header: null,
            headerDonateMobile: null,
            footer: null
        },
        refinedHTML: {
            header: '',
            footer: '',
            csslink: '<link href="https://static.heart.org/ahaanywhere/sitecore/dist/css/aha-header-footer.css" rel="stylesheet">',
            jslink: '\<script type="text/javascript" src="https://static.heart.org/ahaanywhere/sitecore/dist/js/aha-header-footer-main.js"><\/script>'
        },
        textHTML: {
            header: '',
            footer: ''
        },
        errorMsg: 'Something went wrong. Unable to fetch content.',
        fetchingError: false
    }
  },
  mounted() {
    axios.get(this.endpoints.prod)
        .then(response => {
            this.rawHTML.header = response.data.placeholders.header
            this.rawHTML.headerDonateMobile = response.data.placeholders['/header/donate-mobile']
            
            this.rawHTML.footer = response.data.placeholders.footer


            //console.log(Object.entries(this.rawHTML.header));

            var headerFiltered = Object.entries(this.rawHTML.header).filter( (data) => {
                // console.log(data[1].name)
                return data[1].name === 'div';
            })

            // console.log(headerFiltered);
            // console.log(headerFiltered.length);

            var headerDonateMobileFiltered = Object.entries(this.rawHTML.headerDonateMobile).filter( (data,index) => {
                // console.log(data[1].name)
                return data[1].name === 'li';
            })

            // console.log("HEADER DONATE MOBILE");
            // console.log(headerDonateMobileFiltered);

            // this.refinedHTML.header += headerFiltered[0][1].content;
           
            for(let i = 1; i <= headerFiltered.length - 1; i++) {
                if(i === 1 || i === 4) {

                
                    let tempHTML = headerFiltered[i][1]["contents"]
                    .replace(/https:\/\/www.heart.org\/-\/media\/images\/logos\/global-do-no-edit\/header/g, "https:\/\/static.heart.org\/ahaanywhere\/sitecore\/dist\/images")
                    .replace(/https:\/\/www.heart.org\/-\/media\/feature\/navigation\/topnav/g, "https:\/\/static.heart.org\/ahaanywhere\/sitecore\/dist\/images")
                    .replace(/https:\/\/www.heart.org\/-\/media\/project\/common\/glyphs/g, "https:\/\/static.heart.org\/ahaanywhere\/sitecore\/dist\/images")
                    .replace(/<aha-mobile-nav[\s\S]*?<\/aha-mobile-nav>/gm, "")
                    .replace(/<!--Mobila Navigation-->/g, "")
                    // .replace(/[\n]+/, '').trim()
                    // .replace(/[\n\t\r]+/, '')
                    // .replace(/\s{2,10}/g, '\n\t')
                    // .replace(/(\[img.+?\])/gi, '<span class="highlightWord">$1</span>');
                    // <td\s*.*>\s*.*<\/td> Regular expression to match all TD tags:
                    // <\s*a[^>]*>(.*?)<\s*/\s*a> find anchor tag
                    // <pre[\s\S]*?<\/pre> select tag and everything inside
                    // /<li.*(?:^|\W)top(?:$|\W)[\s\S]*?<\/li>/gm - find li with word top and everything between
                    // /<aha-mobile-nav[\s\S]*?<\/aha-mobile-nav>/gm - find aha-mobile-tag and everything in between
                    // /\?.*$/g - find ? and select all til end of string
                    this.refinedHTML.header += tempHTML;
                }
            }

            // console.log(this.refinedHTML.header);


            this.$nextTick(function() {

                const searchIcon = document.querySelector('ul.c-top-nav__nav li:last-child');
                const mobileNav = document.getElementsByTagName('aha-mobile-nav');
                // console.log(mobileNav);
                
                // document.querySelector('div.l-header__top').removeChild(mobileNav);
                document.querySelector('ul.c-top-nav__nav').removeChild(searchIcon);
                var headerImages = document.querySelector('.l-header__top nav').querySelectorAll('img');
                // console.log('HEADER IMAGES:');
                // console.log(headerImages);
                for (const img of headerImages) {
                    let src = img["src"];
                    
                    img["src"] = src.replace(/\?.*$/g,'');
                    // console.log(img["src"]);
                }

                document.querySelector('#aha-header nav ul.c-top-nav__nav').insertAdjacentHTML('beforeend', String(headerDonateMobileFiltered[0][1]["contents"] + '\n'));

                this.refinedHTML.header = String(document.querySelector('#aha-header').outerHTML);

            })


            


            var footerFiltered = Object.entries(this.rawHTML.footer).filter( (data,index) => {
                // console.log(data[1].name)
                return data[1].name === 'div';
            })

            // console.log(footerFiltered);
            // console.log(footerFiltered.length);

            // this.refinedHTML.header += headerFiltered[0][1].content;
            // console.log(footerFiltered[2][1]["contents"]);
            for(let i = 1; i < footerFiltered.length - 1; i++) {
                // if(i !== 3, )
                let tempHTML = footerFiltered[i][1]["contents"]
                .replace(/<div.*(?:^|\W)l-footer__compliance(?:$|\W)[\s\S]*?<\/div>/gm, "") // Remove HONCode compliance div
                .replace(/https:\/\/www.heart.org\/-\/media\/feature\/navigation\/social/g, "https:\/\/static.heart.org\/ahaanywhere\/sitecore\/dist\/images")
                .replace(/https:\/\/www.heart.org\/-\/media\/images\/logos\/global-do-no-edit\/footer/g, "https:\/\/static.heart.org\/ahaanywhere\/sitecore\/dist\/images")
                .replace(/https:\/\/www.heart.org\/-\/media\/images\/logos\/global-do-no-edit\/header/g, "https:\/\/static.heart.org\/ahaanywhere\/sitecore\/dist\/images")
                this.refinedHTML.footer += tempHTML;
            }

            this.$nextTick(function() {

                // Grab all <b-collapse> node and change to <div>
                const collapseDivs = document.querySelectorAll('footer b-collapse');
                // console.log('Collapse Divs');
                // console.log(collapseDivs);
                for (let el of collapseDivs) {
                    el.classList.add('collapse');
                    el.outerHTML = el.outerHTML.replace(/b-collapse/g, 'div');
                    
                }

                const ctaLinks = document.querySelectorAll('footer a.c-cta--arrow');
                const btnHeadingLinks = document.querySelectorAll('footer button[v-b-toggle]');
                const arrowDownSVG = '<svg class="icon-down-arrow" viewBox="0 0 32 32"><path d="M16 25.846c-0.574 0-1.147-0.237-1.586-0.711l-13.755-14.846c-0.879-0.948-0.879-2.477 0-3.424 0.879-0.948 2.295-0.948 3.166 0l12.175 13.141 12.175-13.141c0.879-0.948 2.295-0.948 3.166 0 0.879 0.948 0.879 2.477 0 3.424l-13.755 14.846c-0.439 0.474-1.012 0.711-1.586 0.711h-0z"></path></svg>';
                const arrowRightSVG = '<svg class="icon-right-arrow" viewBox="0 0 32 32"><path d="M16 25.846c-0.574 0-1.147-0.237-1.586-0.711l-13.755-14.846c-0.879-0.948-0.879-2.477 0-3.424 0.879-0.948 2.295-0.948 3.166 0l12.175 13.141 12.175-13.141c0.879-0.948 2.295-0.948 3.166 0 0.879 0.948 0.879 2.477 0 3.424l-13.755 14.846c-0.439 0.474-1.012 0.711-1.586 0.711h-0z"></path></svg>';

                  for (let link of ctaLinks) {
                      link.insertAdjacentHTML('beforeend',arrowRightSVG);
                  }

                  for (let btn of btnHeadingLinks) {
                      btn.setAttribute('aria-expanded', 'false');
                      btn.insertAdjacentHTML('beforeend', arrowDownSVG);
                  }

                this.refinedHTML.footer = String(document.querySelector('#aha-footer').outerHTML);

                

            })

            

        })
        .catch(error => {
            console.log(error);
            this.fetchingError = true;
        })
        .finally(() => {
            console.log('');
            this.addFooterClickEvent();
        })
  },
  methods: {
        onCopy: function (e) {
            console.log(e);
            let originalText = e.trigger.textContent;
            e.trigger.textContent = "Copied";
            setTimeout(() => {
                e.trigger.textContent = originalText;
            }, 1000)
            //e.text
        },
        addFooterClickEvent() {
            console.log('footer menu script');
            FooterMenu();
        }
    }
}
</script>
<style scoped>
pre {
    width: 100%;
}
</style>